import { IAttributes, IAugmentedJQuery, IDirective, IDirectiveFactory, IDirectiveLinkFn, INgModelController, IScope, ITranscludeFunction } from "angular";
import { FeatureToggleV2Service } from "..";

export class FeatureToggleV2 implements IDirective {
  public restrict = "A";
  public transclude = this.ngIf.transclude;
  public priority = this.ngIf.priority - 1;
  public terminal = true;

  constructor(private ngIf: IDirective, private featureToggleService: FeatureToggleV2Service) {}

  public link(scope: IScope, element: IAugmentedJQuery, attrs: IAttributes, ctrl: INgModelController, transclude: ITranscludeFunction): void {
    let featureToggleEnabled: boolean;
    const attrToObserve = attrs.featureToggleEnabledV2 ? "featureToggleEnabledV2" : "featureToggleDisabledV2";

    scope.$on("FeatureFlagV2Updated", () => {
      const featureKey = attrs[attrToObserve];
      this.featureToggleService.isFeatureAvailable(featureKey).then((enabled) => {
        featureToggleEnabled = enabled;
      });
    });

    // until the promise is resolved, always negate the if-expression
    const featureToggleIfEvaluator = (): boolean =>
      typeof featureToggleEnabled === "boolean" && ((attrs.featureToggleEnabledV2 && featureToggleEnabled) || (attrs.featureToggleDisabledV2 && !featureToggleEnabled));

    const initialNgIf = attrs.ngIf;
    let ifEvaluator: () => boolean;
    if (initialNgIf) {
      ifEvaluator = () => featureToggleIfEvaluator() && scope.$eval(initialNgIf);
    } else {
      ifEvaluator = featureToggleIfEvaluator;
    }
    attrs.ngIf = ifEvaluator;

    attrs.$observe<string>(attrToObserve, (featureKey) => {
      this.featureToggleService.isFeatureAvailable(featureKey).then((enabled) => {
        featureToggleEnabled = enabled;
      });
    });

    const ngIfLinkFn = this.ngIf.link as IDirectiveLinkFn;
    ngIfLinkFn.apply(this.ngIf, [scope, element, attrs, ctrl, transclude]);
  }

  public static factory(): IDirectiveFactory {
    const directive = (ngIfDirective: IDirective[], featureToggleServiceV2: FeatureToggleV2Service) => new FeatureToggleV2(ngIfDirective[0], featureToggleServiceV2);
    directive.$inject = ["ngIfDirective", "FeatureToggleV2Service"];
    return directive;
  }
}
